import { ComponentProps, ReactNode, type JSX } from 'react';
import Popover from '../Popover/Popover';
import { DropdownMenuOption } from '../../types';
import styles from './styles/styles.module.scss';
import DropdownMenuItems from './DropdownMenuItems';

type DropdownMenuProps = Pick<
  ComponentProps<typeof Popover>,
  'anchor' | 'className' | 'containerMouseHandlers' | 'isOpen' | 'onCloseRequest' | 'placement' | 'returnFocusOnDeactivate' | 'testId'
> & {
  children?: ReactNode;
  options: DropdownMenuOption[];
};

const DropdownMenu = ({ children, options, ...popoverProps }: DropdownMenuProps): JSX.Element => (
  <Popover {...popoverProps} className={styles.popover}>
    <DropdownMenuItems className={popoverProps.className} options={options}>
      {children}
    </DropdownMenuItems>
  </Popover>
);

export default DropdownMenu;
